// Author Liang Gangqiang
// Date 2021-08-12 10:09:47

import * as model from "@/model/sithMes/rita/SithMesRitaCameraModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesRitaCamera(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_RITA_URL,
    })
    .buildStore()
